import { gql } from 'src/generated/gql';

export const SET_SESSION_OVERLAPPED_AT_MUTATION = gql(`
  mutation SetSessionOverlappedAt($eventId: ID!) {
    staff_setSessionOverlappedAt(eventId: $eventId)
  }
`);
